import { useEffect, useState } from "react";
import { getResponseToState, IPaymentProviderResponse } from "../mappers/getPaymentProviderMapper";
import { useFetch } from "@hooks/useFetch";
import { TIsNewPaymentProvider } from "../interface/IPaymentProvider";
import { getPaymentProviderApiRoute } from "@api-routes/elavonFacade";

export const useGetPaymentProvider = () => {
    const [isNewPaymentProvider, setIsNewPaymentProvider] = useState<TIsNewPaymentProvider>();
    const [paymentProviderState, { get }] = useFetch();

    useEffect(() => {
        get<IPaymentProviderResponse>(getPaymentProviderApiRoute()).then((paymentProviderResponse) => {
            if (paymentProviderResponse) {
                setIsNewPaymentProvider(getResponseToState(paymentProviderResponse));
            }
        });
    }, [get]);

    return { isNewPaymentProvider, paymentProviderState };
};
